import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { notificar } from '../utils/notify';
import '../styles/Contabilidade.css';

const Pendencias = () => {
  const navigate = useNavigate();
  const [pendencias, setPendencias] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [resolvendo, setResolvendo] = useState(null);
  const [mensagem, setMensagem] = useState('');
  const [filtros, setFiltros] = useState({
    empresa: '',
    operador: '',
    competencia: ''
  });

  // Modal de confirmação
  const [mostrarModal, setMostrarModal] = useState(false);
  const [pendenciaParaResolver, setPendenciaParaResolver] = useState(null);

  // Troca de operador (só adm)
  const [podeTrocar, setPodeTrocar] = useState(false);
  const [operadoresCadastro, setOperadoresCadastro] = useState([]);
  const [pendenciaTroca, setPendenciaTroca] = useState(null);
  const [novoOperador, setNovoOperador] = useState('');
  const [trocando, setTrocando] = useState(false);

  useEffect(() => { notificar(mensagem); }, [mensagem]);

  // Carregar pendências do histórico
const carregarPendencias = () => {
  setCarregando(true);
  const accessToken = localStorage.getItem('access');

  axios
    .get(`${process.env.REACT_APP_API_BASE}/api/historico-contabil/`, {
      headers: { Authorization: `Bearer ${accessToken}` }
    })
    .then((res) => {
      const historico = res.data.historico || [];
      
      // Filtrar entregas Parciais E Atrasadas Parciais que NÃO foram resolvidas
      const pendenciasEncontradas = historico.filter(item => {
        const tipo = item.tipo_entrega?.toLowerCase() || '';
        const resolvido = item.resolvido?.toLowerCase() || 'não';
        
        // Verificar ambos os tipos de pendências
        return (tipo === 'parcial' || tipo === 'atrasada e parcial') && resolvido !== 'sim';
      });

      setPendencias(pendenciasEncontradas);
      setCarregando(false);
      
      // Opcional: log para debugging
      console.log(`Total de pendências encontradas: ${pendenciasEncontradas.length}`);
      
      // Opcional: mostrar distribuição por tipo
      const parciaisNormais = pendenciasEncontradas.filter(item => 
        item.tipo_entrega?.toLowerCase() === 'parcial'
      ).length;
      
      const parciaisAtrasadas = pendenciasEncontradas.filter(item => 
        item.tipo_entrega?.toLowerCase() === 'atrasada e parcial'
      ).length;
      
      console.log(`Parciais normais: ${parciaisNormais}, Parciais atrasadas: ${parciaisAtrasadas}`);
    })
    .catch((error) => {
      setMensagem('Erro ao carregar pendências: ' + (error.response?.data?.erro || error.message));
      setCarregando(false);
    });
};

  useEffect(() => {
    carregarPendencias();
    axios
      .get(`${process.env.REACT_APP_API_BASE}/api/pendencia-trocar-operador/`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('access')}` }
      })
      .then((res) => {
        setPodeTrocar(!!res.data.pode_trocar);
        setOperadoresCadastro(res.data.operadores || []);
      })
      .catch(() => setPodeTrocar(false));
  }, []);

  const abrirTroca = (pendencia) => {
    setPendenciaTroca(pendencia);
    setNovoOperador('');
  };

  const fecharTroca = () => {
    if (trocando) return;
    setPendenciaTroca(null);
    setNovoOperador('');
  };

  const trocarOperador = () => {
    if (!pendenciaTroca || !novoOperador) return;
    setTrocando(true);
    axios
      .post(
        `${process.env.REACT_APP_API_BASE}/api/pendencia-trocar-operador/`,
        { id: pendenciaTroca.id, operador: novoOperador },
        { headers: { Authorization: `Bearer ${localStorage.getItem('access')}` } }
      )
      .then((res) => {
        setPendencias(prev => prev.map(p => (p.id === pendenciaTroca.id ? { ...p, operador: novoOperador } : p)));
        setMensagem(res.data.mensagem || 'Operador alterado com sucesso!');
        setPendenciaTroca(null);
        setNovoOperador('');
      })
      .catch((error) => {
        setMensagem('Erro ao trocar operador: ' + (error.response?.data?.erro || error.message));
      })
      .finally(() => setTrocando(false));
  };

  // Abrir modal de confirmação
  const confirmarResolucao = (pendencia) => {
    setPendenciaParaResolver(pendencia);
    setMostrarModal(true);
  };

  // Resolver pendência
// Resolver pendência
const resolverPendencia = () => {
  if (!pendenciaParaResolver) return;

  setResolvendo(pendenciaParaResolver.id);
  const accessToken = localStorage.getItem('access');

  // Log para verificar os dados
  console.log('Dados da pendência para resolver:', {
    id: pendenciaParaResolver.id,
    empresa: pendenciaParaResolver.empresa
  });

  axios
    .post(
      `${process.env.REACT_APP_API_BASE}/api/resolver-pendencia/`,
      {
        id: pendenciaParaResolver.id  // Enviar o ID extraído do objeto
      },
      {
        headers: { Authorization: `Bearer ${accessToken}` }
      }
    )
    .then(() => {
      setMensagem('Pendência marcada como resolvida com sucesso!');
      setMostrarModal(false);
      setPendenciaParaResolver(null);
      setResolvendo(null);
      carregarPendencias(); // Recarregar a lista
    })
    .catch((error) => {
      // Log de erro detalhado
      console.error('Erro ao resolver pendência:', error.response?.data || error);

      setMensagem('Erro ao resolver pendência: ' + (error.response?.data?.erro || error.message));
      setResolvendo(null);
      setMostrarModal(false);
    });
};
  // Filtrar pendências
  const pendenciasFiltradas = pendencias.filter((item) => {
    return Object.entries(filtros).every(([campo, valorFiltro]) => {
      if (!valorFiltro) return true;
      
      let valorItem = '';
      
      switch(campo) {
        case 'competencia':
          valorItem = item.entregue || '';
          break;
        default:
          valorItem = item[campo] || '';
      }
      
      return valorItem.toString().toLowerCase().includes(valorFiltro.toLowerCase());
    });
  });

  // Extrair operadores únicos
  const operadoresUnicos = React.useMemo(() => {
    const operadores = [...new Set(pendencias.map(p => p.operador).filter(Boolean))];
    return operadores.sort();
  }, [pendencias]);

  // Formatar data para exibição
  const formatarData = (dataString) => {
    if (!dataString) return '-';
    try {
      return dataString.split(' ')[0];
    } catch (e) {
      return dataString;
    }
  };

  return (
    <div className="contabilidade-page">
      <div className="container mt-5 shadow p-4 rounded bg-white">
        {/* Cabeçalho */}
        <div className="header-wrapper d-flex justify-content-between align-items-center mb-4">
          <div className="d-flex align-items-center">
            <h2 className="titulo-pagina m-0">Entregas Parciais Pendentes</h2>
          </div>
          <div className="d-flex gap-2">
            <button 
              className="btn btn-outline-primary"
              onClick={carregarPendencias}
              disabled={carregando}
            >
              <i className="fas fa-sync-alt me-2"></i>
              Atualizar
            </button>
            <button 
              className="btn btn-outline-secondary"
              onClick={() => navigate('/contabilidade')}
            >
              <i className="fas fa-arrow-left me-2"></i>
              Voltar
            </button>
          </div>
        </div>

        {/* Mensagens agora são exibidas como toast (react-toastify) */}

        {/* Card de Resumo */}
        <div className="row mb-4">
          <div className="col-md-12">
            <div className="card border-warning">
              <div className="card-body text-center">
                <h5 className="card-title text-warning mb-3">
                  <i className="fas fa-hourglass-half me-2"></i>
                  Total de Entregas Parciais Não Resolvidas
                </h5>
                <h2 className="display-3 text-warning fw-bold">{pendenciasFiltradas.length}</h2>
                <small className="text-muted">Entregas incompletas que precisam ser finalizadas</small>
              </div>
            </div>
          </div>
        </div>

        {/* Filtros */}
        <div className="card mb-4">
          <div className="card-header bg-warning text-dark">
            <h5 className="mb-0">
              <i className="fas fa-filter me-2"></i>
              Filtros
            </h5>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-4">
                <label className="form-label fw-bold">Empresa</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Filtrar por empresa..."
                  value={filtros.empresa}
                  onChange={(e) => setFiltros(prev => ({ ...prev, empresa: e.target.value }))}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label fw-bold">Operador</label>
                <select
                  className="form-select"
                  value={filtros.operador}
                  onChange={(e) => setFiltros(prev => ({ ...prev, operador: e.target.value }))}
                >
                  <option value="">Todos os operadores</option>
                  {operadoresUnicos.map(op => (
                    <option key={op} value={op}>{op}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-4">
                <label className="form-label fw-bold">Competência</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Ex: 10/09/2025"
                  value={filtros.competencia}
                  onChange={(e) => setFiltros(prev => ({ ...prev, competencia: e.target.value }))}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Tabela de Pendências */}
        <div className="card">
          <div className="card-header bg-warning text-dark d-flex justify-content-between align-items-center">
            <h5 className="mb-0">
              <i className="fas fa-table me-2"></i>
              Lista de Entregas Parciais
            </h5>
            <span className="badge bg-dark fs-6">
              {pendenciasFiltradas.length} registro(s)
            </span>
          </div>
          <div className="card-body p-0">
            {carregando ? (
              <div className="text-center py-5">
                <div className="spinner-border text-warning" role="status"></div>
                <p className="mt-2 text-muted">Carregando entregas parciais...</p>
              </div>
            ) : pendenciasFiltradas.length === 0 ? (
              <div className="text-center py-5">
                <i className="fas fa-check-circle fa-4x text-success mb-3"></i>
                <h5 className="text-success">Nenhuma entrega parcial pendente!</h5>
                <p className="text-muted">
                  {filtros.empresa || filtros.operador || filtros.competencia
                    ? 'Nenhum registro corresponde aos filtros aplicados.'
                    : 'Todas as entregas parciais foram resolvidas.'}
                </p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover table-striped mb-0">
                  <thead className="table-warning sticky-top">
                    <tr>
                      <th style={{ minWidth: '150px' }}>Data/Hora</th>
                      <th style={{ minWidth: '280px' }}>Empresa</th>
                      <th style={{ minWidth: '120px' }} className="text-center">Competência</th>
                      <th style={{ minWidth: '100px' }} className="text-center">Nº Domínio</th>
                      <th style={{ minWidth: '120px' }} className="text-center">Operador</th>
                      <th style={{ minWidth: '320px' }}>Observação (O que falta?)</th>
                      <th style={{ minWidth: '100px' }} className="text-center">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pendenciasFiltradas
                      .sort((a, b) => {
                        // Ordenar por data (mais recente primeiro)
                        const dataA = new Date(a.data_hoje);
                        const dataB = new Date(b.data_hoje);
                        return dataB - dataA;
                      })
                      .map((item) => (
                        <tr key={item.id} className="table-warning">
                          <td style={{ fontSize: '0.85rem' }}>
                            <i className="fas fa-calendar-alt me-2 text-muted"></i>
                            {item.data_hoje}
                          </td>
                          <td className="fw-semibold">
                            <i className="fas fa-building me-2 text-primary"></i>
                            {item.empresa}
                          </td>
                          <td className="text-center">
                            <span className="badge bg-primary">
                              <i className="fas fa-calendar-check me-1"></i>
                              {formatarData(item.entregue)}
                            </span>
                          </td>
                          <td className="text-center">
                            <span className="badge bg-secondary">{item.numero_dominio}</span>
                          </td>
                          <td className="text-center">
                            <span className="badge bg-warning text-dark">
                              <i className="fas fa-user me-3"></i>
                              {item.operador || 'N/A'}
                            </span>
                            {podeTrocar && (
                              <button
                                type="button"
                                className="btn btn-link btn-sm p-0 ms-2 align-baseline"
                                onClick={() => abrirTroca(item)}
                                title="Trocar operador da pendência"
                              >
                                <i className="fas fa-exchange-alt"></i>
                              </button>
                            )}
                          </td>
                          <td>
                            {item.texto_livre ? (
                              <div className="text-black">
                                <i className="fas fa-exclamation-circle me-2"></i>
                                <span className="fst-italic fw-semibold">{item.texto_livre}</span>
                                <small className="d-block text-muted mt-1">
                                  <i className="fas fa-clipboard-list me-1"></i>
                                  Pendente de conclusão
                                </small>
                              </div>
                            ) : (
                              <span className="text-muted">
                                <i className="fas fa-minus me-2"></i>
                                Sem observações registradas
                              </span>
                            )}
                          </td>
                          <td className="text-center">
                            <button
                              className="btn btn-success btn-sm"
                              onClick={() => confirmarResolucao(item)}
                              disabled={resolvendo === item.id}
                              title="Marcar como resolvido"
                            >
                              {resolvendo === item.id ? (
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                              ) : (
                                <>
                                  <i className="fas fa-check me-1"></i>
                                  Resolver
                                </>
                              )}
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          <div className="card-footer bg-light">
            <div className="d-flex justify-content-between align-items-center">
              <small className="text-muted">
                <i className="fas fa-info-circle me-1"></i>
                Mostrando apenas entregas <strong>"Parciais"</strong> não resolvidas
              </small>
              <small className="text-muted">
                <i className="fas fa-history me-1"></i>
                Dados do histórico contábil
              </small>
            </div>
          </div>
        </div>
      </div>

      {/* Modal de confirmação */}
      {mostrarModal && pendenciaParaResolver && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
                <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}>
                  <i className="fas fa-check-circle me-2"></i>
                  Confirmar Resolução
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setMostrarModal(false);
                    setPendenciaParaResolver(null);
                  }}
                  disabled={resolvendo}
                ></button>
              </div>
              <div className="modal-body">
                <p className="mb-2">Tem certeza que deseja marcar esta pendência como resolvida?</p>
                <div className="alert alert-info">
                  <strong>Empresa:</strong> {pendenciaParaResolver.empresa}<br />
                  <strong>Competência:</strong> {formatarData(pendenciaParaResolver.entregue)}<br />
                  <strong>Operador:</strong> {pendenciaParaResolver.operador}<br />
                  {pendenciaParaResolver.texto_livre && (
                    <>
                      <strong>Observação:</strong> {pendenciaParaResolver.texto_livre}
                    </>
                  )}
                </div>
                <p className="text-success small mb-0">
                  <i className="fas fa-info-circle me-1"></i>
                  Esta ação marcará a entrega como resolvida e ela não aparecerá mais nesta lista.
                </p>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={() => {
                    setMostrarModal(false);
                    setPendenciaParaResolver(null);
                  }}
                  disabled={resolvendo}
                >
                  Cancelar
                </button>
                <button 
                  type="button" 
                  className="btn btn-success" 
                  onClick={resolverPendencia}
                  disabled={resolvendo}
                >
                  {resolvendo ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Resolvendo...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-check me-2"></i>
                      Confirmar Resolução
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de troca de operador (só adm) */}
      {pendenciaTroca && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
                <div>
                  <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}>
                    <i className="fas fa-exchange-alt me-2"></i>
                    Trocar Operador
                  </h5>
                  <small style={{ color: '#6c757d' }}>
                    {pendenciaTroca.empresa} · {formatarData(pendenciaTroca.entregue)}
                  </small>
                </div>
                <button type="button" className="btn-close" onClick={fecharTroca} disabled={trocando}></button>
              </div>
              <div className="modal-body">
                <p className="mb-2">
                  Operador atual: <strong>{pendenciaTroca.operador || 'N/A'}</strong>
                </p>
                <label className="form-label fw-bold">Novo operador</label>
                <select
                  className="form-select"
                  value={novoOperador}
                  onChange={(e) => setNovoOperador(e.target.value)}
                  disabled={trocando}
                >
                  <option value="">Selecione...</option>
                  {operadoresCadastro
                    .filter(op => op !== pendenciaTroca.operador)
                    .map(op => (
                      <option key={op} value={op}>{op}</option>
                    ))}
                </select>
                <p className="text-muted small mt-2 mb-0">
                  <i className="fas fa-info-circle me-1"></i>
                  Muda só o responsável por esta pendência; o operador do cliente no cadastro continua o mesmo.
                </p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={fecharTroca} disabled={trocando}>
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={trocarOperador}
                  disabled={trocando || !novoOperador}
                >
                  {trocando ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Salvando...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-check me-2"></i>
                      Trocar
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Pendencias;